type Translate = (key: string, options?: Record<string, unknown>) => string;

/** One "VIA X — Página n de N" label per physical page. N is the whole PDF (content + trailing report pages). */
export function buildPageCounterLabels({ viaNames, pagesPerPart, trailingPages, t }: {
  viaNames: string[]; pagesPerPart: number[]; trailingPages: number; t: Translate;
}): string[] {
  const total = pagesPerPart.reduce((a, b) => a + b, 0) + trailingPages;
  const labels: string[] = [];
  let page = 0;
  pagesPerPart.forEach((count, partIndex) => {
    for (let i = 0; i < count; i++) {
      page += 1;
      const pageText = t("print.vias.pageNofM", { n: page, total });
      labels.push(viaNames[partIndex] ? `${viaNames[partIndex]} — ${pageText}` : pageText);
    }
  });
  for (let i = 0; i < trailingPages; i++) {
    page += 1;
    labels.push(t("print.vias.pageNofM", { n: page, total }));
  }
  return labels;
}
